module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('line-chart', {
    ref: "cpuTrendChart",
    attrs: {
      "chartData": _vm.cpu.trend.chartData,
      "options": _vm.cpu.trend.chartOptions
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0df8a38a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/server-charts/CpuChart.vue
// module id = 2138
// module chunks = 1